// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedInfo_container__XSd9I"};